import { Typography } from '@material-ui/core'
import React from 'react'

export const passwordError =
  <div>
    <Typography variant="body2" component="p">
      Password must contain
    </Typography>
    <Typography variant="body2" component="p">
      At least one number
    </Typography>
    <Typography variant="body2" component="p">
      At least one uppercase
    </Typography>
    <Typography variant="body2" component="p">
      At least one lowercase
    </Typography>
    <Typography variant="body2" component="p">
      At least 8 characters
    </Typography>
    <Typography variant="body2" component="p">
      At least one special sign
    </Typography>
  </div>